const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricelocqLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.487,
    height: 39.524,
    viewBox: "0 0 109 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Small-PriceLocq-White"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    width: 109,
    height: 22,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M31.27,5.85a4.86,4.86,0,0,0-3.73,1.51A5.09,5.09,0,0,0,26,11.07v8.31h1.79V15A5,5,0,0,0,31,16.3h.2a4.87,4.87,0,0,0,3.52-1.5A5.2,5.2,0,0,0,36.25,11,5.15,5.15,0,0,0,34.8,7.42a4.91,4.91,0,0,0-3.53-1.57m3.15,5.29a3.27,3.27,0,0,1-1,2.37,3.22,3.22,0,0,1-2.35,1,3,3,0,0,1-2.28-1,3.34,3.34,0,0,1-1-2.36,3.43,3.43,0,0,1,1-2.52,3,3,0,0,1,2.26-1h.19a3.11,3.11,0,0,1,2.27,1.08,3.34,3.34,0,0,1,.91,2.4",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M40.25,6.26h0a3.47,3.47,0,0,0-.76.56V6.06H37.74v10h1.89V10.14a2.56,2.56,0,0,1,.28-1.31,3.27,3.27,0,0,1,.68-.71,2,2,0,0,1,1.25-.41h.28V5.9h-.28a3.1,3.1,0,0,0-1.6.38",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    x: 43.87,
    y: 6.07,
    width: 1.8,
    height: 10,
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M55.63,12.85a3.39,3.39,0,0,1-3.06,1.64,3.48,3.48,0,0,1-3.5-3.44,3.26,3.26,0,0,1,1.12-2.46,3.32,3.32,0,0,1,2.36-1h.06a3.31,3.31,0,0,1,3,1.73l.08.14h2l-.35-.81a4.64,4.64,0,0,0-1.87-2,5.37,5.37,0,0,0-2.84-.82h-.09a5.37,5.37,0,0,0-3.78,1.59,5.12,5.12,0,0,0-.09,7.24l.14.13a5.37,5.37,0,0,0,3.73,1.52h.06a5.12,5.12,0,0,0,4.79-2.87l.33-.7h-2Z",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M64.18,5.8h-.33a4.88,4.88,0,0,0-3.54,1.52,5.19,5.19,0,0,0-.09,7.37l.12.13a5,5,0,0,0,3.56,1.48H64a5.12,5.12,0,0,0,3-1,5,5,0,0,0,1.89-2.56l.13-.37H67l-.08.16A3.05,3.05,0,0,1,64,14.47a3.32,3.32,0,0,1-2.31-.84,3.18,3.18,0,0,1-1.07-1.86h8.43v-1a4.81,4.81,0,0,0-1.42-3.37A5.15,5.15,0,0,0,64.18,5.8m3,4.25H60.67a3.18,3.18,0,0,1,1.09-1.67,3.49,3.49,0,0,1,4.35,0,3.41,3.41,0,0,1,1.07,1.64",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    x: 70.31,
    y: 2.74,
    width: 1.82,
    height: 13.32,
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M78.76,5.83A4.83,4.83,0,0,0,75,7.34a5.28,5.28,0,0,0-.12,7.36,4.9,4.9,0,0,0,3.54,1.58h.2a4.82,4.82,0,0,0,3.52-1.49,5.22,5.22,0,0,0,.12-7.35,4.93,4.93,0,0,0-3.54-1.61M81.93,11a3.37,3.37,0,0,1-1,2.51,2.9,2.9,0,0,1-2.25,1H78.5a3,3,0,0,1-2.27-1.06,3.35,3.35,0,0,1-.9-2.42,3.24,3.24,0,0,1,1-2.37,3.09,3.09,0,0,1,2.3-1h.07a3,3,0,0,1,2.25,1,3.49,3.49,0,0,1,1,2.36",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M93.31,12.85a3.4,3.4,0,0,1-3.06,1.64,3.48,3.48,0,0,1-3.5-3.44,3.26,3.26,0,0,1,1.12-2.46,3.3,3.3,0,0,1,2.36-1h.06a3.3,3.3,0,0,1,3,1.73l.08.14h2L95,8.67a4.67,4.67,0,0,0-1.86-2,5.37,5.37,0,0,0-2.84-.82h-.09a5.41,5.41,0,0,0-3.79,1.59,5.12,5.12,0,0,0-.08,7.24l.14.13a5.37,5.37,0,0,0,3.73,1.52h.06a5.13,5.13,0,0,0,4.79-2.87l.33-.7h-2Z",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M104.65,7.36a5,5,0,0,0-3.57-1.51h-.2a4.86,4.86,0,0,0-3.54,1.58A5.06,5.06,0,0,0,95.91,11a5.19,5.19,0,0,0,1.55,3.76,4.84,4.84,0,0,0,3.74,1.49A4.92,4.92,0,0,0,104.38,15v4.35h1.81v-8.3a4.91,4.91,0,0,0-1.54-3.72m-.3,3.8a3.41,3.41,0,0,1-1,2.36,3,3,0,0,1-2.27,1,3.18,3.18,0,0,1-2.36-1,3.32,3.32,0,0,1-1-2.37,3.36,3.36,0,0,1,.9-2.4,3.14,3.14,0,0,1,2.27-1.09h.18a3,3,0,0,1,2.26,1,3.49,3.49,0,0,1,1,2.52",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    x: 43.87,
    y: 2.74,
    width: 1.8,
    height: 1.8,
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M31.27,5.85a4.86,4.86,0,0,0-3.73,1.51A5.09,5.09,0,0,0,26,11.07v8.31h1.79V15A5,5,0,0,0,31,16.3h.2a4.87,4.87,0,0,0,3.52-1.5A5.2,5.2,0,0,0,36.25,11,5.15,5.15,0,0,0,34.8,7.42a4.91,4.91,0,0,0-3.53-1.57m3.15,5.29a3.27,3.27,0,0,1-1,2.37,3.22,3.22,0,0,1-2.35,1,3,3,0,0,1-2.28-1,3.34,3.34,0,0,1-1-2.36,3.43,3.43,0,0,1,1-2.52,3,3,0,0,1,2.26-1h.19a3.11,3.11,0,0,1,2.27,1.08,3.34,3.34,0,0,1,.91,2.4",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M40.25,6.26h0a3.47,3.47,0,0,0-.76.56V6.06H37.74v10h1.89V10.14a2.56,2.56,0,0,1,.28-1.31,3.27,3.27,0,0,1,.68-.71,2,2,0,0,1,1.25-.41h.28V5.9h-.28a3.1,3.1,0,0,0-1.6.38",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    x: 43.87,
    y: 6.07,
    width: 1.8,
    height: 10,
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M55.63,12.85a3.39,3.39,0,0,1-3.06,1.64,3.48,3.48,0,0,1-3.5-3.44,3.26,3.26,0,0,1,1.12-2.46,3.32,3.32,0,0,1,2.36-1h.06a3.31,3.31,0,0,1,3,1.73l.08.14h2l-.35-.81a4.64,4.64,0,0,0-1.87-2,5.37,5.37,0,0,0-2.84-.82h-.09a5.37,5.37,0,0,0-3.78,1.59,5.12,5.12,0,0,0-.09,7.24l.14.13a5.37,5.37,0,0,0,3.73,1.52h.06a5.12,5.12,0,0,0,4.79-2.87l.33-.7h-2Z",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M64.18,5.8h-.33a4.88,4.88,0,0,0-3.54,1.52,5.19,5.19,0,0,0-.09,7.37l.12.13a5,5,0,0,0,3.56,1.48H64a5.12,5.12,0,0,0,3-1,5,5,0,0,0,1.89-2.56l.13-.37H67l-.08.16A3.05,3.05,0,0,1,64,14.47a3.32,3.32,0,0,1-2.31-.84,3.18,3.18,0,0,1-1.07-1.86h8.43v-1a4.81,4.81,0,0,0-1.42-3.37A5.15,5.15,0,0,0,64.18,5.8m3,4.25H60.67a3.18,3.18,0,0,1,1.09-1.67,3.49,3.49,0,0,1,4.35,0,3.41,3.41,0,0,1,1.07,1.64",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    x: 70.31,
    y: 2.74,
    width: 1.82,
    height: 13.32,
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M78.76,5.83A4.83,4.83,0,0,0,75,7.34a5.28,5.28,0,0,0-.12,7.36,4.9,4.9,0,0,0,3.54,1.58h.2a4.82,4.82,0,0,0,3.52-1.49,5.22,5.22,0,0,0,.12-7.35,4.93,4.93,0,0,0-3.54-1.61M81.93,11a3.37,3.37,0,0,1-1,2.51,2.9,2.9,0,0,1-2.25,1H78.5a3,3,0,0,1-2.27-1.06,3.35,3.35,0,0,1-.9-2.42,3.24,3.24,0,0,1,1-2.37,3.09,3.09,0,0,1,2.3-1h.07a3,3,0,0,1,2.25,1,3.49,3.49,0,0,1,1,2.36",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M93.31,12.85a3.4,3.4,0,0,1-3.06,1.64,3.48,3.48,0,0,1-3.5-3.44,3.26,3.26,0,0,1,1.12-2.46,3.3,3.3,0,0,1,2.36-1h.06a3.3,3.3,0,0,1,3,1.73l.08.14h2L95,8.67a4.67,4.67,0,0,0-1.86-2,5.37,5.37,0,0,0-2.84-.82h-.09a5.41,5.41,0,0,0-3.79,1.59,5.12,5.12,0,0,0-.08,7.24l.14.13a5.37,5.37,0,0,0,3.73,1.52h.06a5.13,5.13,0,0,0,4.79-2.87l.33-.7h-2Z",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M104.65,7.36a5,5,0,0,0-3.57-1.51h-.2a4.86,4.86,0,0,0-3.54,1.58A5.06,5.06,0,0,0,95.91,11a5.19,5.19,0,0,0,1.55,3.76,4.84,4.84,0,0,0,3.74,1.49A4.92,4.92,0,0,0,104.38,15v4.35h1.81v-8.3a4.91,4.91,0,0,0-1.54-3.72m-.3,3.8a3.41,3.41,0,0,1-1,2.36,3,3,0,0,1-2.27,1,3.18,3.18,0,0,1-2.36-1,3.32,3.32,0,0,1-1-2.37,3.36,3.36,0,0,1,.9-2.4,3.14,3.14,0,0,1,2.27-1.09h.18a3,3,0,0,1,2.26,1,3.49,3.49,0,0,1,1,2.52",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M18.23,8.19a7,7,0,0,0-.47-1L20,6a13.2,13.2,0,0,1,.62,1.32Zm-1.11-2a7.21,7.21,0,0,0-.74-.82l1.75-1.82a8.38,8.38,0,0,1,1,1.08ZM15.49,4.67a8.24,8.24,0,0,0-1-.57L15.7,1.85A9.91,9.91,0,0,1,17,2.61Z",
    style: {
      fill: "#4982cf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M16.39,9.44A5.61,5.61,0,1,1,9.45,5.61h0a5.61,5.61,0,0,1,6.94,3.83",
    style: {
      fill: "#4982cf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M17.9,14.77l1.67,1.67a10.16,10.16,0,0,0,1.48-6.92l-2.27.36a7.78,7.78,0,0,1-.88,4.89",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M14.53,18A7.86,7.86,0,1,1,12.91,3.37l.6-2.21a10.15,10.15,0,1,0,2.7,18.55Z",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    x: 15.06,
    y: 10.79,
    width: 2.29,
    height: 11.19,
    transform: "translate(-6.84 16.26) rotate(-45)",
    style: {
      fill: "#4982cf"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricelocqLogo);
export default __webpack_public_path__ + "static/media/pricelocq-logo.c146bd37ca7af30ffa25b34a5d6a3907.svg";
export { ForwardRef as ReactComponent };